function getMostFrequentElement(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return null;
  
    const countMap = new Map();
  
    // 统计每个元素的出现次数
    arr.forEach(item => {
      countMap.set(item, (countMap.get(item) || 0) + 1);
    });
  
    let maxCount = 0;
    let mostFrequentElement = null;
  
    // 找到出现次数最多的元素
    for (const [element, count] of countMap.entries()) {
      if (count > maxCount) {
        maxCount = count;
        mostFrequentElement = element;
      }
    }
  
    return mostFrequentElement;
  }
  
  export default getMostFrequentElement;